import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Container, Form, Button, Alert, Spinner } from 'react-bootstrap';
import AuthNavbar from '../navbars/AuthNavbar';
import axios from 'axios';

function RegisterPage() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState(null);
    const [isRegistering, setIsRegistering] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);

        if (password !== confirmPassword) {
            setError('Heslá sa nezhodujú.');
            return;
        }

        setIsRegistering(true);
        try {
            await axios.post(`${process.env.REACT_APP_BACKEND_URL}/auth/register`, {
                username,
                password,
                confirm_password: confirmPassword  // Include this only if your backend expects it
            });
            navigate('/login', { state: { msg: 'Registrácia úspešná. Skontroluj svoj e-mail a aktivuj si účet cez odkaz, ktorý sme ti poslali. Skontroluj aj SPAM priečinok.' } });
        } catch (err) {
            setError(err.response?.data?.detail || 'Chyba pri registrácii.');
        }
        setIsRegistering(false);
    };

    return (
        <>
            <AuthNavbar />
            <Container className="mt-4">
                <h2 className="text-center">Registrácia</h2>
                {error && <Alert variant="danger">{error}</Alert>}
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label>Email (Bude slúžiť ako prihlasovacie meno)</Form.Label>
                        <Form.Control
                            type="email"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Heslo</Form.Label>
                        <Form.Control
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Potvrď heslo</Form.Label>
                        <Form.Control
                            type="password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                        />
                    </Form.Group>

                    <Button type="submit" className="w-100" disabled={isRegistering}>
                        {isRegistering && <Spinner as="span" size="sm" className="me-2" />}
                        Registrovať
                    </Button>
                </Form>

                <div className="d-flex justify-content-between mt-3">
                    <Link to="/login">Už máš účet? Prihlás sa</Link>
                    <Link to="/auth/forgot-password">Zabudol si heslo?</Link>
                </div>
            </Container>
        </>
    );
}

export default RegisterPage;
